export default __webpack_public_path__ + "static/media/bg.05d0d9ab.jpg";